import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

export const absoluteUrl = (path) => `${BASE}${path}`;

export const track = (type, extra = {}) => {
  try {
    api.post("/events", { type, ...extra }).catch(() => {});
  } catch (e) {}
};

// ---- order token persistence (guest, no account) ----
export const saveOrderToken = (orderId, token) => {
  try {
    localStorage.setItem(`acte_order_${orderId}`, token);
  } catch (e) {}
};
export const getOrderToken = (orderId) => {
  try {
    return localStorage.getItem(`acte_order_${orderId}`);
  } catch (e) {
    return null;
  }
};

export const RON = (bani) => `${(bani / 100).toFixed(0)} lei`;
